<template>
  <div>
    <b-modal
      id="add-campaign"
      ref="modal"
      header-class="headerModal"
      no-close-on-backdrop
      centered
      title="Invite leads to campaign"
      hide-footer
    >
      <b-form-group>
        <div v-if="isAllChecked == true">
          {{ $t('You have invited all of the leads') }}
        </div>
        <div v-else>
          {{ clients.length }} {{ $t('leads have been invited to the campaign') }}
        </div>
      </b-form-group>

      <b-form-group :label="$t('Select Campaign')">
        <b-form-select
          v-model="selectedCampaignId"
          :options="campaignOptions"
          style="
            padding: 11.5px;
            color: #82868c;
            border-radius: 8px;
            width: 100%;
            border: 1px solid lightgray;
          "
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              -- {{ $t('Please select a campaign') }} --
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          style="margin-left: 0px; background: #FF274F !important;"
          class="buttonSubmit"
          :disabled="!selectedCampaignId"
          @click="onSubmit()"
        >
          {{ $t('Confirm') }}
        </b-button>
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; background: white; color: black; border-color: white; font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['clients', 'isAllChecked'],
  data() {
    return {
      modalTriggeredByToggle: false,
      selectedCampaignId: null,
    }
  },
  computed: {
    ...mapGetters(['getCampaigns']),
    
    campaignOptions() {
      if (!this.getCampaigns) return [];
      return this.getCampaigns.map(c => ({
        value: c.id || c.campaignId,
        text: c.name || c.campaign || ''
      }));
    }
  },
  mounted() {
    this.campaignPagination({ pageNumber: 1, pageSize: 15 });
  },
  methods: {
    ...mapActions(['campaignPagination']),
    
    onSubmit() {
      if (!this.selectedCampaignId) return;
      
      const payload = {
        campaignId: this.selectedCampaignId,
        clients: this.clients,
        isAllChecked: this.isAllChecked
      };
      
      this.$emit('confirmInvite', payload);
      this.$refs.modal.hide();
    },
    onCancel() {
      this.selectedCampaignId = null;
      this.$refs.modal.hide();
    },
  },
}
</script>